import { Component, OnInit } from '@angular/core';
import { UserDto } from '../_core/_model/users';
import { ApiService } from '../_core/_services/api.service';
import { MainCurrencyDto } from '../_core/_model/currency';
import { NotificationService } from '../_core/_services/notification.service';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class Dashboard implements OnInit {
  loading = false;
  error = '';
  userData!: UserDto;
  currencies: MainCurrencyDto[] = [];
  fee = 0.0;

  constructor(
    private notifyService: NotificationService,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.getDetails();
    this.loadMain();
  }

  refresh(): void {
    this.getDetails();
    this.loadMain();
  }

  getDetails(): void {
    this.api.getProfile().subscribe({
      next: data => {
        this.userData = data.data;
      },
      error: error => {
        this.error = error?.error?.Error?.Details ?? 'Failed to load profile';
        this.notifyService.showError(this.error, 'Error');
      }
    });
  }

  loadMain(): void {
    this.loading = true;

    this.api.getMain().subscribe({
      next: response => {
        this.currencies = (response.data?.currencies ?? [])
          .filter(currency => currency.status === 'Active');
      },
      error: error => {
        this.error = error?.error?.Error?.Details ?? 'Failed to load main data';
        this.notifyService.showError(this.error, 'Error');
      },
      complete: () => (this.loading = false),
    });
  }
}
